/**
 * Who curates the Notification Letter exemplar library.
 *
 * Matthew's direction (2026-08-12): "it should only be added for me, no
 * one else is adding these gold standards" — so the add/edit/remove
 * surfaces render only for his account, not for the admin role. The
 * backend enforces the same allowlist server-side
 * (NOTIFICATION_EXEMPLAR_CURATOR_EMAILS, doc_pipeline/config.py);
 * hiding here is UX, not security.
 *
 * Interim mechanism: this constant folds into the /auth/me capability
 * registry when the parked user-capabilities plan is signed off.
 */
export const NOTIFICATION_LETTER_CURATOR_EMAILS = [
  "mgreig@wernerhoffman.com",
];

export const canCurateNotificationLetters = (user) => {
  const email = (user?.email || "").toLowerCase();
  return Boolean(email) && NOTIFICATION_LETTER_CURATOR_EMAILS.includes(email);
};
